export const ROLES_APP = {
  MEDICO: 'medico',
}
